import * as React from 'react';
import Color from '../data/Color';
import UIFlex, {copyFlex, IFlex} from './UIFlex';

import { IconifyIcon } from '@iconify/react';
import UIIcon from './UIIcon';

import './UIStatusBanner.scss';
import { UICloseButton } from './UIButton';
import Size from '../data/Size';


export interface IStatus{
    id:string;
    type:string;
    content:string | JSX.Element;
}

export interface IUIStatusBannerProps{
    className?:string;
    flex?:IFlex;
    status:IStatus;
    fontSize?:string;
    onClose?:($status:IStatus)=>void;
}
export interface IUIStatusBannerState{
    closing:boolean;
    height?:number;
    marginBot?:number;
    insideTranslateY?:number;
}

export default class UIStatusBanner extends React.Component<IUIStatusBannerProps,IUIStatusBannerState> {
    static TYPE_SUCCESS:string = "success";
    static TYPE_ERROR:string = "error";
    static TYPE_WARNING:string = "warning";
    static TYPE_INFO:string = "info";

    inside:React.RefObject<HTMLDivElement> = React.createRef();

    constructor($props:IUIStatusBannerProps){
        super($props);

        this.state = {
            closing:false,
        }
    }

    componentDidMount(){
        requestAnimationFrame(()=>{
            this._updateHeight();
        });

        window.addEventListener("resize", this._onResize);
    }

    componentWillUnmount(){
        window.removeEventListener("resize", this._onResize);
        window.clearTimeout(this._debounceID);
        window.clearTimeout(this._timeoutID);
        
    }
    _debounceID:number=-1;
    _onResize=()=>{
        
        window.clearTimeout(this._debounceID);
        this._debounceID = window.setTimeout(()=>{
            this._updateHeight();
        },400);
    }

    _updateHeight=()=>{
        if(this.inside.current){
            this.setState({height:this.inside.current.clientHeight, marginBot:10, insideTranslateY:0});
        }
    }
    _timeoutID:number=-1;
    _close=()=>{
        this.setState({closing:true},()=>{
            window.clearTimeout(this._timeoutID);
            this._timeoutID = window.setTimeout(()=>{
                if(this.props.onClose){
                    this.props.onClose(this.props.status);
                }
            },401);
        });
    }
    render() {
        let cn:string = "statusBanner";
        if(this.props.className) cn+=" "+this.props.className;
        if(this.state.closing) cn+=" closing";

        cn = Size.addFontSize(cn,this.props.fontSize,Size.s16);

        let icon:IconifyIcon = UIIcon.CHECK_CIRCLE;//default cause why not
        let color:string = "";

        switch(this.props.status.type){
            case UIStatusBanner.TYPE_SUCCESS:
                color = Color.GREEN;
                icon = UIIcon.CHECK_CIRCLE;
            break;
            case UIStatusBanner.TYPE_INFO:
                color = Color.BLUE;
                icon = UIIcon.CHECK_CIRCLE;
            break;
            case UIStatusBanner.TYPE_WARNING:
                color = Color.YELLOW;
                icon = UIIcon.CHECK_CIRCLE;
            break;
            case UIStatusBanner.TYPE_ERROR:
                color = Color.RED;
                icon = UIIcon.CANCEL;
            break;
        }


        let height:number = this.state.height || 0;
        let insideTranslateY = this.state.insideTranslateY;
        let marginBottom:number = this.state.marginBot || 0;

        if(this.state.closing){
            height = 0;
            insideTranslateY = -50;//this is a percent
            marginBottom = 0;
        }
        
        return (
            <UIFlex className={cn} flex={copyFlex({style:{height:height, marginBottom:marginBottom}},this.props.flex)}>
                <div ref={this.inside} className={"inside bgcolor_"+color+"-light"} style={{transform:"translate(0,"+insideTranslateY+"%)"}}>
                    <UIIcon icon={icon}/>
                    <div className="inside_content">
                        {this.props.status.content}
                    </div>
                    {this.props.onClose && (
                        <UICloseButton onClick={this._close} size={Size.s50}/>
                    )}
                </div>
            </UIFlex>
        );
    }
}

